/**
 * Клас для управління прокручуванням сторінки.
 * 
 * @package AGDS
 * @category Modules
 * @module Scroll
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class Scroll {
	
	/**
	 * Конструктор
	 *
	 * @param {Object} options
	 */
	constructor(options = {}) {
		this.header = options.header
		this.windowWidth = options.windowWidth
	}

	/**
	 * Ініціалізація
	 * 
	 * @returns {void}
	 */
	init() {
		this.smoothScrollToAnchor()
		this.backToTopButton()
	}

	/**
	 * Плавне прокручування до посилань.
	 * Враховує висоту хедера при прокрутці.
	 * 
	 * @returns {void}
	 */
	smoothScrollToAnchor() {
		const anchorLinks = document.querySelectorAll('a[href*="#"]:not([data-fancybox])')
		if (!anchorLinks.length) return

		anchorLinks.forEach(anchor => {
			anchor.addEventListener('click', event => {
				const href = anchor.getAttribute('href')
				const hash = href.split('#')[1]

				// Перевірка на наявність елемента з відповідним id
				if (hash && document.getElementById(hash)) {
					event.preventDefault()
					const headerHeight = this.header ? this.header.offsetHeight : 0
					const targetOffset = document.getElementById(hash).offsetTop - headerHeight
					this.scrollToWindowTop(targetOffset)
				}
			})
		})
	}

	/**
	 * Скролл до верху сторінки.
	 * 
	 * @param {number} top - Висота скроллу
	 * @returns {void}
	 */
	scrollToWindowTop(top = 0) {
		window.scrollTo({ top: top, behavior: "smooth" })
	}

	/**
	 * Плавне прокручування "Наверх" по кнопці.
	 * 
	 * @returns {void}
	 */
	backToTopButton() {
		const backToTopBtn = document.getElementById('backtotop-btn')
		if (!backToTopBtn) return

		backToTopBtn.addEventListener('click', (e) => {
			e.preventDefault()
			this.scrollToWindowTop()
		})
	}
}
